export default __webpack_public_path__ + "static/media/BHS_black_logo.0177711a.svg";